export default function () {
    this.conf.classNames.selected = 'current-menu-item';
    var wpadminbar = document.getElementById('wpadminbar');
    if (wpadminbar) {
        wpadminbar.style.position = 'fixed';
        wpadminbar.classList.add('mm-slideout');
    }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/wrappers/wordpress/mmenu.wordpress.js
// module id = 492
// module chunks = 0